export const DEFAULT_ACCOUNT_NAME_MAX_LENGTH = 40;
export const DEFAULT_ACCOUNT_NAME_MIN_LENGTH = 1;
export const DEFAULT_ACCOUNT_DESCRIPTION_MAX_LENGTH = 50000;

export const LOGO_ACCEPT_FORMATS = ['image/png', 'image/jpeg', 'image/gif'];
export const LOGO_SIZE_LIMIT = 1024 * 1024 * 4; // 4 Mb
